import React from 'react';

import { ApolloProvider } from '@apollo/client';
import PropTypes from 'prop-types';

import { LocationProvider } from '@adsk/acc-locations-components';
import { useCurrentProjectId } from '@adsk/alloy-provider';

import photosApolloClient from './helpers/gql/createApolloClient';
import { PlangridLaunchDarklyProvider } from './PlangridLaunchDarklyProvider';

const PhotoProvider = ({ children }) => {
  const projectId = useCurrentProjectId();
  return (
    <LocationProvider projectId={projectId}>
      <PlangridLaunchDarklyProvider>
        <ApolloProvider client={photosApolloClient}>{children}</ApolloProvider>
      </PlangridLaunchDarklyProvider>
    </LocationProvider>
  );
};

PhotoProvider.propTypes = {
  children: PropTypes.node,
};

export default PhotoProvider;
